import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useCallback } from "react";

interface ConfirmAddendumActionModalProps {
  opened: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  confirmColor?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmAddendumActionModal({
  opened,
  title,
  message,
  confirmLabel,
  confirmColor = "red",
  loading = false,
  onCancel,
  onConfirm,
}: ConfirmAddendumActionModalProps) {
  const handleConfirm = useCallback(() => {
    onConfirm();
  }, [onConfirm]);

  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title={title}
      centered
      closeOnClickOutside={false}
      closeOnEscape={!loading}
    >
      <Stack>
        <Text size="sm">{message}</Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>
            Keep editing
          </Button>
          <Button
            color={confirmColor}
            loading={loading}
            onClick={handleConfirm}
          >
            {confirmLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
